/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Blob_Save_Dialog_ReplaceInputs */



/**
* | output |
* | --- |
* | "Replace an existing file with the same name" |
*
* @param {Chat_Blob_Save_Dialog_ReplaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_blob_save_dialog_replace = /** @type {((inputs?: Chat_Blob_Save_Dialog_ReplaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Blob_Save_Dialog_ReplaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorhandene Datei mit demselben Namen ersetzen")
	return /** @type {LocalizedString} */ ("Replace an existing file with the same name")
});